module.exports = __webpack_public_path__ + "img/直播.5d334fdd.png";